import React from "react";
import {IGridConfigItem} from "../../../../constants/interfaces";

type Props = {
	item: IGridConfigItem,
	updateConfig: Function
}

const WeightedResult = (props: Props) => {
	return (
		<div className="config-item__show-circles mb-2 mt-2">
			<label className="control control-checkbox"
				   htmlFor={`checkbox-weighted-${props.item.cell_id}`}>
				<input type="checkbox"
					   id={`checkbox-weighted-${props.item.cell_id}`}
					   onChange={() => props.updateConfig(['weighted_result'], [props.item.weighted_result === 1 ? 0 : 1])}
					   value="weighted_result"
					   checked={!!props.item.weighted_result}
				/>
				<div className="control-indicator"></div>
				Show weighted results
			</label>
		</div>
	);
};

export default WeightedResult;
